import styled from 'styled-components';
import { ReferenceTypePreview } from '@ardoq/renderers';
import { ViewLegendItem } from './ViewLegendItem';
import { ViewLegendItemLabel } from './ViewLegendItemLabel';
import { ViewLegendReferenceType } from './types';

const ViewLegendReferenceItemLabel = styled(ViewLegendItemLabel)`
  .forExport & {
    line-height: unset;
    height: unset;
    max-height: unset;
    flex: 3 1 auto;
  }
`;

const ViewLegendReferenceItem = styled(ViewLegendItem)`
  align-items: flex-start;

  > svg {
    flex: unset;
    width: 42px;
    min-width: 42px;
    height: 20px;
  }
`;

interface ViewLegendReferenceProperties {
  referenceType: ViewLegendReferenceType;
}
const ViewLegendReference = ({
  referenceType,
}: ViewLegendReferenceProperties) => (
  <ViewLegendReferenceItem>
    <ReferenceTypePreview height={20} width={42} {...referenceType} />
    <ViewLegendReferenceItemLabel>
      {referenceType.name}
    </ViewLegendReferenceItemLabel>
  </ViewLegendReferenceItem>
);

export { ViewLegendReference };
